import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {Box, Button, Card, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, makeStyles } from '@material-ui/core';
import { v4 as uuid } from 'uuid';
import { Link as RouterLink } from "react-router-dom";

const data = [
  {
    id: uuid(),
    vehicleType: 'Automobile',
    plate: 'SZ-VB-69',
    passengerCapacity: 5,
    status: 'Available'
  },
  {
    id: uuid(),
    vehicleType: 'SUV',
    plate: 'SZ-SB-69',
    passengerCapacity: 6,
    status: 'In Use'
  },
  {
    id: uuid(),
    vehicleType: 'SUV',
    plate: 'SZ-VB-72',
    passengerCapacity: 7,
    status: 'Available'
  },
  {
    id: uuid(),
    vehicleType: 'Midibus',
    plate: 'SZX-VB-693',
    passengerCapacity: 15,
    status: 'Available'
  },
  {
    id: uuid(),
    vehicleType: 'Midibus',
    plate: 'SZ-VBW-69',
    passengerCapacity: 25,
    status: 'In Use'
  },
  {
    id: uuid(),
    vehicleType: 'Automobile',
    plate: 'SZ-VBC-69',
    passengerCapacity: 4,
    status: 'Available'
  },
  {
    id: uuid(),
    vehicleType: 'Automobile',
    plate: 'SZ-VBS-69',
    passengerCapacity: 3,
    status: 'In Use'
  },
];

const useStyles = makeStyles((theme) => ({
  root: {},
  available: { backgroundColor: "#EFFFEF" },
  inUse: { backgroundColor: "#FFEFEF" },
  otherButton: {
    marginBottom: theme.spacing(3)
  }
}));

const VehicleList = ({ className, ...rest }) => {
  const classes = useStyles();
  const [selectedWorkRequestIds, setSelectedWorkRequestIds] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [workrequests] = useState(data);

  const handleSelectAll = (event) => {
    let newSelectedWorkRequestIds;

    if (event.target.checked) {
      newSelectedWorkRequestIds = workrequests.map((workrequest) => workrequest.id);
    } else {
      newSelectedWorkRequestIds = [];
    }

    setSelectedWorkRequestIds(newSelectedWorkRequestIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedWorkRequestIds.indexOf(id);
    let newSelectedWorkRequestIds = [];

    if (selectedIndex === -1) {
      newSelectedWorkRequestIds = newSelectedWorkRequestIds.concat(selectedWorkRequestIds, id);
    } else if (selectedIndex === 0) {
      newSelectedWorkRequestIds = newSelectedWorkRequestIds.concat(selectedWorkRequestIds.slice(1));
    } else if (selectedIndex === selectedWorkRequestIds.length - 1) {
      newSelectedWorkRequestIds = newSelectedWorkRequestIds.concat(selectedWorkRequestIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedWorkRequestIds = newSelectedWorkRequestIds.concat(
        selectedWorkRequestIds.slice(0, selectedIndex),
        selectedWorkRequestIds.slice(selectedIndex + 1)
      );
    }

    setSelectedWorkRequestIds(newSelectedWorkRequestIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <div>
      <Button className={classes.otherButton} color="primary" variant="outlined" component={RouterLink} to="../vehicle_form">Add Vehicle</Button>
      <Card className={clsx(classes.root, className)} {...rest}>
        <PerfectScrollbar>
          <Box minWidth={1050}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Vehicle Type</TableCell>
                  <TableCell>Plate</TableCell>
                  <TableCell>Passenger Capacity</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {workrequests.slice(0, limit).map((workrequest) => (
                  <TableRow className={clsx(workrequest.status === 'Available' ? classes.available : classes.inUse, className)} hover key={workrequest.id} selected={selectedWorkRequestIds.indexOf(workrequest.id) !== -1}>
                    <TableCell>{workrequest.vehicleType}</TableCell>
                    <TableCell>{workrequest.plate}</TableCell>
                    <TableCell>{workrequest.passengerCapacity}</TableCell>
                    <TableCell>{workrequest.status}</TableCell>
                    <TableCell><Button variant="outlined">View Details</Button></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </PerfectScrollbar>
        <TablePagination component="div" 
          count={workrequests.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[10, 50, 100]} />
      </Card>
    </div>
  );
};

VehicleList.propTypes = {
  className: PropTypes.string,
  workrequests: PropTypes.array.isRequired
};

export default VehicleList;
